import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function GetAll(areaId = 0, areaUId = null, deviceType, accessToken) {
  var payload = {
    areaId,
    areaUId,
    deviceType,
  };
  return {
    type: Pre.DEVICE + Actions.ALL,
    payload,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function ClearAll() {
  return {
    type: Pre.DEVICE + Actions.CLEAR,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function Add(model) {
  return {
    type: Pre.DEVICE + Actions.ADD,
    payload: { model },
  };
}

export function AddGPIO(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.ADD_GPIO,
    payload: model,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function AddSmartSpeaker(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.ADD_SMART_SPEAKER,
    payload: model,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function RestoreMotionDetectionLocally(deviceId) {
  var payload = {
    deviceId: 0,
    deviceUId: null,
    detected: false,
  };
  if (typeof deviceId === "string") payload.deviceUId = deviceId;
  else if (typeof deviceId === "number") payload.deviceId = deviceId;

  return {
    type: Pre.MOTION_SENSOR + Actions.UPDATE_VALUE,
    payload: {
      data: JSON.stringify(payload),
    },
    socket: {
      send: false, // do not send to server, handle locally
    },
  };
}

export function TryInclude(areaId = 0, areaUId = null, accessToken) {
  var payload = {
    areaId,
    areaUId,
  };
  return {
    type: Pre.DEVICE + Actions.INCLUDE_NODE,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function GetDetails(
  deviceId = 0,
  deviceUId = null,
  deviceType,
  accessToken
) {
  var payload = {
    deviceId,
    deviceUId,
    deviceType,
  };

  return {
    type: Pre.DEVICE + Actions.DETAILS,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function tryIncludeToHomeId(
  areaId = 0,
  areaUId = null,
  homeId,
  accessToken
) {
  var payload = {
    homeId,
    areaId,
    areaUId,
  };
  return {
    type: Pre.DEVICE + Actions.INCLUDE_NODE,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function Remove(deviceId) {
  var payload = {
    deviceId: 0,
    deviceUId: null,
  };
  if (typeof deviceId === "string") payload.deviceUId = deviceId;
  else if (typeof deviceId === "number") payload.deviceId = deviceId;

  return {
    type: Pre.DEVICE + Actions.REMOVE,
    payload,
  };
}

export function Update(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.UPDATE,
    accessToken,
    payload: { model },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function UpdateGPIO(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.UPDATE_GPIO,
    accessToken,
    payload: model,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function UpdateSmartSpeaker(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.UPDATE_SMART_SPEAKER,
    payload: model,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function Heal(deviceId, accessToken) {
  var payload = {
    deviceId: 0,
    deviceUId: null,
  };
  if (typeof deviceId === "string") payload.deviceUId = deviceId;
  else if (typeof deviceId === "number") payload.deviceId = deviceId;

  return {
    type: Pre.DEVICE + Actions.HEAL,
    payload,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function CountDownIncludeTimeout() {
  return {
    type: Pre.DEVICE + Actions.COUNT_DOWN_TIMEOUT,
    payload: {},
    socket: {
      send: false,
    },
  };
}

export function ResetIncludeTimeout() {
  return {
    type: Pre.DEVICE + Actions.INCLUDE_NODE_GET_TIMEOUT,
    payload: {},
    socket: {
      send: false,
    },
  };
}

export function resetNewIncludedNodeLocally() {
  return {
    type: Pre.DEVICE + Actions.RESET_NEW_INCLUDED_ID,
    payload: {},
    socket: {
      send: false,
    },
  };
}

export function GetAllPlaylists(accessToken) {
  return {
    type: Pre.DEVICE + Pre.PLAY_LIST + Actions.ALL,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function DeletePlaylist(id, uId, accessToken) {
  return {
    type: Pre.DEVICE + Pre.PLAY_LIST + Actions.DELETE,
    accessToken,
    payload: { id, uId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function AddPlaylistLocally(playList) {
  return {
    type: Pre.DEVICE + Pre.PLAY_LIST + Actions.ADD,
    payload: playList,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function UpdatePlaylistLocally(playList) {
  return {
    type: Pre.DEVICE + Pre.PLAY_LIST + Actions.UPDATE,
    payload: playList,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function AddTrackLocally(track, playListId) {
  return {
    type: Pre.DEVICE + Pre.PLAY_LIST + Actions.ADD_TRACK,
    payload: { ...track, playListId },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function RemoveTrackLocally(trackId, playListId) {
  return {
    type: Pre.DEVICE + Pre.PLAY_LIST + Actions.REMOVE_TRACK,
    payload: { trackId, playListId },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function ReOrderTracksLocally(playListId, tracks) {
  return {
    type: Pre.DEVICE + Pre.PLAY_LIST + Actions.RE_ORDER_TRACKS,
    payload: { tracks, playListId },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

// === Touch Panel ===
export function addTouchPanel(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.ADD_TOUCH_PANEL,
    accessToken,
    payload: model,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
export function updateTouchPanel(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.UPDATE_TOUCH_PANEL,
    accessToken,
    payload: model,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
export function clearNewTouchPanel() {
  return {
    type: Pre.DEVICE + Actions.CLEAR_NEW_TOUCH_PANEL,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

// === Access Control ===
export function addAccessControl(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.ADD_ACCESS_CONTROL,
    payload: model,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function updateAccessControl(model, accessToken) {
  return {
    type: Pre.DEVICE + Actions.UPDATE_ACCESS_CONTROL,
    payload: model,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

// === Add and Update Device Controller ===
export function UpdateDeviceControllerForm(model) {
  return {
    type: Pre.DEVICE + Actions.UPDATE_CONTROLLER,
    payload: model,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function UpdateController(action, deviceId, deviceUId, nextVersion) {
  return {
    type: Pre.DEVICE + Actions.UPDATE_CONTROLLER,
    payload: { action, deviceId, deviceUId, nextVersion },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
